export default class ZTablePagination {
  no
  size

  constructor (pageNo, pageSize) {
    this.no = pageNo
    this.size = pageSize
  }
}



// WEBPACK FOOTER //
// ./src/components/ZTable/ZTablePagination.js